import { SystemConfig } from "../common/type-state";

export enum APIHosts {
    Identity = "hostIdentity",
    Stream = "hostStream",
    File = "hostFile",
    Conversion = "hostConversion",
    DOCAIVIEWER = "hostDOCAIViewer",
    Bim = "hostBim",
    DOCAI = "hostDOCAI",
}

export class ApiReduxHelpers {
    config = {} as SystemConfig;
    getHost = (apiHost: APIHosts): string => {
        console.log("Getting API host for:", apiHost);
        console.log("Setting API config:", this.config);
        let host = this.config[apiHost] || "";
        if (host.endsWith("/")) {
            host = host.slice(0, -1);
        }
        return host;
    };
    setConfig = (config: SystemConfig): this => {
        this.config = config;
        return this;
    };
}
